module.exports = __webpack_public_path__ + "img/contact_us_side.0a605a36.png";